import { render, staticRenderFns } from "./GridIcon.vue?vue&type=template&id=180a48c6"
import script from "./GridIcon.vue?vue&type=script&lang=js"
export * from "./GridIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports